<template>
    <div class="page__content persons">
        <div class="columns">
            <div class="column is-8">
                <h2 class="page__headline">{{persons ? persons.length : ''}} {{ $t('persons.headline') }}</h2>
                <p class="page__copy">
                    {{ $t('persons.copy') }}
                </p>
            </div>
        </div>

        <draggable class="columns is-multiline is-widescreen" v-bind="dragOptions" v-model="persons" @end="onSortedEnd">
            <div class="column is-12 is-half-widescreen" v-for="(key, index) in persons" :key="key.id">
                <div class="persons__person">
                    <person v-model="persons[index]" :seasons="seasons" @del="openModal(index)"></person>
                </div>
            </div>
        </draggable>

        <div class="is-clearfix">
            <a class="button is-primary is-pulled-left" @click="addPerson()">{{ $t('persons.addPerson') }}</a>
            <router-link class="button is-pulled-right" exact :to="{ name: 'extras', params: {lang: lang} }" @click.native="nextStepClicked()">
                <span class="icon is-small">
                    <i class="fa fa-arrow-right" aria-hidden="true"></i>
                </span>
                <span>{{ $t('persons.editExtras') }}</span>
            </router-link>
        </div>

        <div class="modal isActive" :class="{ 'is-active': modal.isActive }">
            <div class="modal-background" @click="closeModal()"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{ modal.title }}</p>
                    <button class="delete" @click="closeModal()"></button>
                </header>
                <section class="modal-card-body" v-html="modal.content">
                </section>
                <footer class="modal-card-foot is-clearfix">
                    <a class="button" @click="closeModal()">{{ $t('generic.cancel') }}</a>
                    <a class="button is-danger" @click="deletePerson()">
                            <span class="icon">
                                <i class="fa fa-trash" aria-hidden="true"></i>
                            </span>
                        <span>{{ $t('generic.delete') }}</span>
                    </a>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';

    import { Api } from '../../../api';
    import { AppModel } from '../../../models';
    import { EventBus, Tracking } from '../../../utils';
    import { Person } from '../../components';

    export default {
        name: 'persons',

        components: {
            draggable,
            Person
        },

        beforeRouteEnter(to, from, next) {
            Api.bootstrap().then(function(response) {
                return Promise.all([response, Api.persons.fetchPersons()]);
            }).then(function(response) {
                next((vm) => {
                    vm.persons = response[1].body;
                });
            });
        },

        beforeDestroy() {
            this.deleteUnsavedPersons();
        },

        data() {
            return {
                dragOptions: {
                    handle: '.edit-box__dragger',
                    ghostClass: 'sortable-ghost',
                },
                modal: {
                    isActive: false,
                    title: null,
                    content: null
                },
                persons: null,
                seasons: this.getSeasons(),
            };
        },

        created() {

        },

        computed: {
            lang() {
                return AppModel.lang;
            },
        },

        methods: {
            getSeasons() {
                if(AppModel.onlyDayPrices) {
                    return [{'id': -1, 'is_lock': false, 'name': 'Standardpreise'}];
                }
                return AppModel.activeCampground.seasons;
            },
            addPerson() {
                let person = {
                    description: null,
                    name: null,
                    person_type: null,
                    prices: []
                };
                for(let season of this.seasons) {
                    if(!season.is_lock) {
                        for(let key in AppModel.campsiteTypes) {
                            if(AppModel.campsiteTypes.hasOwnProperty(key)) {
                                person.prices.push({ 'campsite_type': key, 'season_id': season.id, value: 0 });
                            }
                        }
                    }
                }
                Tracking.trackEvent('Persons', 'addPerson', null, null);
                this.persons.push(person);
                // scroll to position of added element which in this case is end of page
                setTimeout(() => {
                    document.body.scrollTop = this.$el.scrollHeight;
                }, 0);
            },

            deletePerson() {
                Api.persons.deletePerson(this.modal.person)
                    .then((response) => {
                        if(Math.floor(response.status / 100) === 2) {
                            this.persons.splice(this.modal.index, 1);
                            Api.bootstrap(true);
                            EventBus.$emit(EventBus.UPDATE_CHECKS);
                            Tracking.trackEvent('Persons', 'delete', 'success', null);
                        } else {
                            console.error('delete failed', response);
                            EventBus.$emit(EventBus.SHOW_NOTIFICATION, {
                                title: 'Die Person konnte nicht gelöscht werden',
                                body: response.body.message,
                                type: 'danger',
                                direction: 'Up',
                                duration: 5000,
                            });
                            Tracking.trackEvent('Persons', 'delete', 'failed', null);
                        }
                    }, (response) => {
                        console.log('delete failed', response);
                        Tracking.trackEvent('Persons', 'delete', 'failed', null);
                    });
                this.closeModal();
            },

            closeModal() {
                this.modal.isActive = false;
            },

            openModal(index) {
                if(!this.persons[index].id) {
                    this.persons.splice(index, 1);
                    Tracking.trackEvent('Persons', 'discardUnsaved', null, null);
                    return;
                }
                // if season is saved season, show warning modal
                this.modal.title = this.$t('generic.warning');
                this.modal.content = this.$t('generic.modal.delete', { name: this.persons[index].name });
                this.modal.isActive = true;
                this.modal.person = this.persons[index];
                this.modal.index = index;
            },

            onSortedEnd() {
                let ordering = [];
                this.persons.forEach(function(element) {
                    ordering.push(element.id);
                });
                Api.persons.oderPerson({ 'order': ordering })
                    .then((response) => {
                        if(response.ok) {
                            Tracking.trackEvent('Persons', 'sort', 'success', null);
                        } else {
                            console.log('order update failed');
                            Tracking.trackEvent('Persons', 'sort', 'failed', null);
                        }
                    }, () => {
                        console.log('order update failed');
                        Tracking.trackEvent('Persons', 'sort', 'failed', null);
                    });
            },

            deleteUnsavedPersons() {
                for(let person in this.persons) {
                    if(!this.persons[person].id) {
                        this.persons.splice(person, 1);
                        Tracking.trackEvent('Persons', 'discardUnsavedOnLeave', null, null);
                    }
                }
            },

            nextStepClicked() {
                Tracking.trackEvent('Persons', 'nextStep', 'settings', null);
            }
        },
    };
</script>

<style lang="scss">
    @import 'persons.scss';
</style>



// WEBPACK FOOTER //
// src/views/pages/persons/persons.vue